import Components from './../Component';
import ComponentFactory from "../ComponentFactory";
import Accessibility from "./Accessibility";
import Accordion from "./Accordion";
import Breadcrumb from "./Breadcrumb";
import FormFilter from "./FormFilter";
import FormAjax from "./FormAjax";
import FormItemCondition from "./FormItemCondition";
import Gallery from "./Gallery";
import Sidebar from "./Sidebar";
import Slider from "./Slider";
import Menu from "./Menu";
import Modal from "./Modal";
import Ads from "./Ads";
import Timeago from "./Timeago";
import Tooltip from "./Tooltip";
import Search from "./Search";
import Realtime from "./Realtime";
import ViewMore from "./ViewMore";
import IntranetBus from "./IntranetBus";
import Ascenseur from "./Ascenseur";
import WaitingLines from "./WaitingLines";
import Tabs from "./Tabs";
import Walkthrough from "./Walkthrough";
import FloatingHelper from "./FloatingHelper";
import CookieBanner from "./CookieBanner";
import Flipbook from "./Flipbook";

export default class Liveticker extends Components {

  constructor($) {
    super($);
    this.lang = $('body').attr('data-language');
    this.timeout = null;
  }

  init(index, element) {
    this.element = element;
    this.refresh(element);

    if (!this.$(element).hasClass('liveticker-banner')) {
      this.get(element);
    }

    //Add red emojo if there is not one
    if (document.title.indexOf('🔴') === -1)
    {
      document.title = '🔴 ' + document.title;
    }


    setInterval(function(){
      this.updateCount(element);
    }.bind(this), 15000);

    $ = this.$;

    //liveticker-last-updates-mobile
    if (this.$('.liveticker-last-updates-mobile').length > 0) {
      //scrollto .messages-timeline
      this.$('.liveticker-last-updates-mobile').on('click', function () {
        this.refresh(element);
        this.$('html, body').animate({
          scrollTop: this.$('.messages-timeline').offset().top - 100
        }, 500);
      }.bind(this));

      //Hide when scroll y .messages-timeline is in viewport

      $.fn.isInViewport = function() {
        var elementTop = $(this).offset().top;
        var elementBottom = elementTop + $(this).outerHeight();
        var viewportTop = $(window).scrollTop();
        var viewportBottom = viewportTop + $(window).height();
        return elementBottom > viewportTop && elementTop < viewportBottom;
      };

      $(window).scroll(function () {

        if ($('.messages-timeline').isInViewport()) {
          // The element is visible, do something
          $('.liveticker-last-updates-mobile').hide();
        } else {
          // The element is NOT visible, do something else
          $('.liveticker-last-updates-mobile').css('display', 'inline-flex');
        }
      });

    }

  }

  updateCount(element){
    this.$.getJSON('/'+this.lang+'/liveticker/' + this.$(element).attr('data-liveticker') + '/count', function (data) {
      //console.log(data);
      //console.log(data.count - jQuery('.messages-timeline li').length);

      let count = data.count - jQuery('.messages-timeline li').length;
      let datetime = data.datetime;

      //Update the count in the badge foreach span.liveticker-count
      if (count > 0) {
        jQuery('.liveticker-count').html('(' + count + ')');
      } else {
        jQuery('.liveticker-count').html('');
      }

      if (datetime){
        jQuery('.liveticker-datetime').attr('datetime', datetime);
        jQuery("time").timeago('updateFromDOM');
      }

    });
  }

  refresh(element){
    this.$(element).find('.refresh').on('click', function () {
      if (!this.$(element).find('.refresh').hasClass('disabled')) {
        this.get(element);
        this.$(element).find('.refresh').addClass('disabled');
      }
      return false;
    }.bind(this));
    this.updateCount(element);
  }

  get(element) {

    this.$.getJSON('/'+this.lang+'/liveticker/' + this.$(element).attr('data-liveticker') + '/messages', function (data) {
      console.log('messages');
      this.$(element).html(data.html);

      new ComponentFactory(jQuery);
      ComponentFactory.register('Accordion', Accordion);
      ComponentFactory.register('Gallery', Gallery);
      ComponentFactory.register('Slider', Slider);
      ComponentFactory.register('Timeago', Timeago);
      ComponentFactory.register('ViewMore', ViewMore);
      ComponentFactory.register('Ascenseur', Ascenseur);
      ComponentFactory.register('Tabs', Tabs);
      //ComponentFactory.register('Liveticker', Liveticker);

      this.refresh(element);

    }.bind(this));
  }
}
